import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CreateFamsApprovalPayload,
  FamsApprovalItem,
  FamsApprovalList,
  FamsApprovalListParams,
  ReviewFamsApprovalPayload,
} from './types/approval';

const request = createAppRequest();

export async function getFamsApprovals(
  params?: FamsApprovalListParams,
  options?: ApiRequestOptions,
) {
  return request<FamsApprovalList>('/bff/fams/approvals', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsApproval(
  id: number,
  options?: ApiRequestOptions,
) {
  return request<FamsApprovalItem>(`/bff/fams/approvals/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createFamsApproval(
  payload: CreateFamsApprovalPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsApprovalItem>('/bff/fams/approvals', {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function approveFamsApproval(
  id: number,
  payload?: ReviewFamsApprovalPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsApprovalItem>(`/bff/fams/approvals/${id}/approve`, {
    method: 'POST',
    data: payload || {},
    ...(options || {}),
  });
}

export async function rejectFamsApproval(
  id: number,
  payload: ReviewFamsApprovalPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsApprovalItem>(`/bff/fams/approvals/${id}/reject`, {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function cancelFamsApproval(
  id: number,
  options?: ApiRequestOptions,
) {
  return request<FamsApprovalItem>(`/bff/fams/approvals/${id}/cancel`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteFamsApproval(
  id: number,
  options?: ApiRequestOptions,
) {
  return request<{ success: boolean; id: number }>(`/bff/fams/approvals/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
